import React, { useEffect, useState } from 'react';
import { adminApi, ADMIN_TOKEN_KEY } from './adminApi';

const AdminAuthContext = React.createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem(ADMIN_TOKEN_KEY);
    if (!token) {
      setLoading(false);
      return;
    }
    adminApi
      .get('/admin/auth/me')
      .then((res) => setAdmin(res.data))
      .catch(() => {
        localStorage.removeItem(ADMIN_TOKEN_KEY);
        setAdmin(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    try {
      const res = await adminApi.post('/admin/auth/login', { email, password });
      localStorage.setItem(ADMIN_TOKEN_KEY, res.data.access_token);
      const me = await adminApi.get('/admin/auth/me');
      setAdmin(me.data);
      return { success: true };
    } catch (e) {
      const detail = e?.response?.data?.detail;
      return { success: false, error: typeof detail === 'string' ? detail : 'Login failed' };
    }
  };

  const logout = () => {
    localStorage.removeItem(ADMIN_TOKEN_KEY);
    setAdmin(null);
  };

  return (
    <AdminAuthContext.Provider value={{ admin, loading, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  const ctx = React.useContext(AdminAuthContext);
  if (!ctx) throw new Error('useAdminAuth must be used inside <AdminAuthProvider>');
  return ctx;
}
